/**
 * #1110: the one display name for a Polymarket US player statistic.
 *
 * NFL families that settle on the same statistic as Kalshi's read with
 * Kalshi's label, so a trader sees one name per stat on a game. A shared label
 * is display only: it never pairs a US contract with a Kalshi market. `td` on
 * US excludes passing touchdowns, so it keeps its own label. Stats with no
 * Kalshi counterpart keep their US label; an unknown slug is shown as given.
 */
import { NFL_PROP_STAT_LABELS } from '@/lib/kalshiTicker/sports/nfl';

const KALSHI_SHARED = [
  'pass-yds', 'pass-td', 'pass-att', 'pass-comp', 'pass-int', 'rec-yds', 'rec', 'long-rec',
  'rush-yds', 'rush-att', 'rush-rec-yds', 'first-td',
] as const;

const US_ONLY: Record<string, string> = {
  points: 'Points', assists: 'Assists', rebounds: 'Rebounds', threes: 'Three-pointers',
  steals: 'Steals', blocks: 'Blocks', 'double-double': 'Double-double', 'triple-double': 'Triple-double',
  td: 'Touchdowns (Excl. Passing)', 'fantasy-ppr': 'Fantasy points (PPR)',
  'team-first-td': "Team's first touchdown", 'most-passing-yards': 'Most passing yards',
};

const LABELS: Record<string, string> = {
  ...US_ONLY,
  ...Object.fromEntries(KALSHI_SHARED.map(stat => [stat, NFL_PROP_STAT_LABELS[stat]])),
};

export function usStatLabel(stat: string): string {
  return Object.prototype.hasOwnProperty.call(LABELS, stat) ? LABELS[stat] : stat;
}
